import {Link} from '@genomics-dev/denim-components';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {
    DoctorsMessage,
    ReportDownloadButton,
} from '../../../../components';
import {Routes} from '../../../../Routes';
import {TalkToDoctorOption} from './TalkToDoctorOption';

export function TalkToDoctor() {
    const intl = useIntl();

    return (
        <section
            className={'talk-to-doctor section-divider layout two-thirds'}
            data-test-id={'talk-to-doctor-section'}
        >
            <div className={'sidebar'}>
                <h2 data-test-id={'talk-to-doctor-title'}>
                    <FormattedMessage id={'reports.trait.talkToDoctor.title'} />
                </h2>
                <div
                    className={'count is-caption is-heavy'}
                    data-test-id={'talk-to-doctor-step-count'}
                >
                    <FormattedMessage id={'reports.trait.talkToDoctor.options'} />
                </div>
            </div>
            <div className={'content talk-to-doctor-content'}>
                <TalkToDoctorOption
                    currentStep={1}
                    dataTestId={'talk-to-doctor-option-1'}
                    title={intl.formatMessage({id: 'reports.trait.talkToDoctor.shareResults.title'})}
                    totalSteps={2}
                >
                    <>
                        <p
                            className={'no-margin'}
                            data-test-id={'option-1-description'}
                        >
                            <FormattedMessage
                                id={'reports.trait.talkToDoctor.shareResults.description'}
                            />
                        </p>
                        <DoctorsMessage />
                        <ReportDownloadButton dataTestId={`download-button`}>
                            <FormattedMessage id={'common.button.downloadReport'} />
                        </ReportDownloadButton>
                    </>
                </TalkToDoctorOption>
                <TalkToDoctorOption
                    currentStep={2}
                    dataTestId={'talk-to-doctor-option-2'}
                    title={intl.formatMessage({id: 'reports.trait.talkToDoctor.bookConsultation.title'})}
                    totalSteps={2}
                >
                    <>
                        <p
                            className={'no-margin'}
                            data-test-id={'option-2-description-1'}
                        >
                            <FormattedMessage
                                id={'reports.trait.talkToDoctor.bookConsultation.description.one'}
                            />
                        </p>
                        <p
                            className={'no-margin'}
                            data-test-id={'option-2-description-2'}
                        >
                            <FormattedMessage
                                id={'reports.trait.talkToDoctor.bookConsultation.description.two'}
                            />
                        </p>
                        <ul
                            className={'no-margin'}
                            data-test-id={'option-2-capabilities-list'}
                        >
                            <li data-test-id={'capability-item-1'}>
                                <FormattedMessage
                                    id={'reports.trait.talkToDoctor.bookConsultation.item.one'}
                                />
                            </li>
                            <li data-test-id={'capability-item-2'}>
                                <FormattedMessage
                                    id={'reports.trait.talkToDoctor.bookConsultation.item.two'}
                                />
                            </li>
                            <li
                                className={'no-bottom-margin'}
                                data-test-id={'capability-item-3'}
                            >
                                <FormattedMessage
                                    id={'reports.trait.talkToDoctor.bookConsultation.item.three'}
                                />
                            </li>
                            <li
                                className={'no-bottom-margin'}
                                data-test-id={'capability-item-4'}
                            >
                                <FormattedMessage
                                    id={'reports.trait.talkToDoctor.bookConsultation.item.four'}
                                />
                            </li>
                        </ul>
                        <Link
                            className={'button icon after launch'}
                            dataTestId={'consultation-button'}
                            rel={'noreferrer'}
                            target={'_blank'}
                            url={Routes.HELP_CENTER}
                        >
                            <FormattedMessage
                                id={'reports.trait.talkToDoctor.bookConsultation.learnConsultation.button.text'}
                            />
                        </Link>
                    </>
                </TalkToDoctorOption>
                <div
                    className={'is-caption disclaimer'}
                    data-test-id={'talk-to-doctor-disclaimer'}
                >
                    <FormattedMessage id={'reports.trait.lifestyleActions.disclaimer'} />
                </div>
            </div>
        </section>
    );
}
